import { CallRetentionPolicyTypes } from 'generated/graphql-types';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { CallRetentionPolicyOption } from '../models/call-retention-policy-option';
import { callRetentionPolicyOptionActions } from './call-retention-policy-option.actions';


export const callRetentionPolicyOptionFeatureKey = 'callRetentionPolicyOptions';

export type CallRetentionPolicyOptionState = EagerSelectState<CallRetentionPolicyOption>;

const adapter = createEagerSelectAdapter<CallRetentionPolicyOptionState, CallRetentionPolicyOption>({
   featureKey: callRetentionPolicyOptionFeatureKey,
   selectId: (callRetentionPolicy: CallRetentionPolicyOption) => {
      return callRetentionPolicy.callRetentionPolicy ? callRetentionPolicy.callRetentionPolicy : '';
   },
});

export const callRetentionPolicyOptionSelectors = adapter.getSelectors(filterCallRetentionPolicyNameOption);

const initialState = adapter.getInitialState();

export const callRetentionPolicyOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   callRetentionPolicyOptionActions.search,
   callRetentionPolicyOptionActions.searchReset,
   callRetentionPolicyOptionActions.loadFromApi,
   callRetentionPolicyOptionActions.loadFromApiSuccess,
   callRetentionPolicyOptionActions.loadFromApiFailure
);

const policyData = {
   Eighteen: '18 Months',
   ThirtySix: '36 Months',
   Sixty: '60 Months',
   NegativeOne: 'Unset',
};

export function filterCallRetentionPolicyNameOption<T extends CallRetentionPolicyOption>(
   types: T[],
   searchText: string | null | undefined
): T[] {
   const filteredOptions: T[] = Object.keys(policyData)
      .filter((callRetentionPolicy) => {
         const duration = policyData[callRetentionPolicy];
         return searchText ? duration.toLowerCase().includes(searchText.toLowerCase()) : true;
      })
      .map((callRetentionPolicy) => {
         return { callRetentionPolicy } as T;
      })
      .sort((a, b) => {
         if (a.callRetentionPolicy === 'NegativeOne') {
            return 1;
         } else if (b.callRetentionPolicy === 'NegativeOne') {
            return -1;
         } else if (a.callRetentionPolicy === 'Sixty') {
            return 1;
         } else if (b.callRetentionPolicy === 'Sixty') {
            return -1;
         } else if (a.callRetentionPolicy === 'ThirtySix') {
            return 1;
         } else if (b.callRetentionPolicy === 'ThirtySix') {
            return -1;
         } else if (a.callRetentionPolicy === 'Eighteen') {
            return 1;
         } else if (b.callRetentionPolicy === 'Eighteen') {
            return -1;
         } else {
            return 0;
         }
      });
   return filteredOptions;
}